export default "__VITE_ASSET__B$ZIQmKm__"